<template>
  <div class="no">
    <img :src="$store.state.imgHeadUrl + 'noContent.png'" alt="">
    <div class="no-word">当前内容已下架，请查看其他内容</div>
  </div>
</template>
<script>
export default {
  name: 'NoContent',
};
</script>
<style lang="less" scoped>
@media screen and (min-width: 1000px) {
  .no {
    width: 690px !important;
  }
}
.no {
  width: 100vw;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 240px;
    height: 240px;
  }
  &-word {
    font-size: 14px;
    color: #9898A2;
    position: relative;
    top: -18px;
  }
}
</style>